export default {"src":"/_next/static/media/matterport-yacht.db1a2518.svg","height":43,"width":43,"blurWidth":0,"blurHeight":0};